<template>
  <div class="account-item">
    <LetterAvatar :account-id="accountId" :name="label" large />
    <div v-tooltip="wrapperTooltip" class="!flex !flex-col !items-start !gap-1">
      <div class="!flex !gap-1">
        <slot :label="label" :account-id="accountId">
          <p>{{ label }}</p>
        </slot>
      </div>
      <p v-if="subLabel" class="!text-xs !text-gray-500">{{ subLabel }}</p>
    </div>

    <ToggleSwitch
      v-model="toggleValue"
      :disabled="disabled"
      :tooltip="toggleTooltip"
      class="switcher"
      @update:model-value="(value) => emit('change', value)"
    />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';

import LetterAvatar from '@/components/LetterAvatar.vue';
import ToggleSwitch from '@/components/ToggleSwitch.vue';

const {
  accountId,
  disabled = false,
  label,
  toggled = false,
  toggleTooltip = '',
  wrapperTooltip = null,
  subLabel = null,
} = defineProps<{
  accountId: string | number;
  disabled?: boolean;
  label: string;
  toggled?: boolean;
  toggleTooltip?: string;
  wrapperTooltip?: string | { content: string; html: boolean } | null;
  subLabel?: string | null;
}>();

const emit = defineEmits<{
  change: [value: boolean];
}>();

const toggleValue = ref(toggled);
</script>

<style scoped lang="postcss">
.account-item {
  display: flex;
  text-align: center;
  padding: var(--space-16);
  align-items: center;

  p {
    margin-left: var(--space-16);
  }

  .switcher {
    margin-left: auto;
  }

  .brand-photo {
    width: var(--space-40);
    height: var(--space-40);
    border-radius: 50%;
    display: block;
  }

  :deep(.dh-letter-avatar) {
    margin-left: 0;
  }
}
</style>
